package com.klantenstop.web.pages.healthcare

import androidx.compose.runtime.Composable
import com.klantenstop.web.components.H1Heading
import com.klantenstop.web.components.layout.PageLayout
import com.klantenstop.web.components.layout.PageSeoConfig
import com.klantenstop.web.navigation.Navigation
import com.materialkobweb.components.sections.NavigationItem
import com.materialkobweb.styles.MaterialColorVars
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.px

@Page("/patientenstop-wachtlijst")
@Composable
fun PatientStopWaitlistPage() {
    val breakpoint = rememberBreakpoint()

    PageLayout(
        title = "Patiëntenstop en wachtlijst uitgelegd",
        seo = PageSeoConfig.Managed(
            description = "Wat betekent patiëntenstop of wachtlijst bij een huisarts of tandarts? Ontdek hoe KlantenStop je helpt sneller een beschikbare zorgverlener te vinden.",
            indexable = true,
            keywords = listOf(
                "patientenstop",
                "patienten stop",
                "wachtlijst huisarts",
                "wachtlijst tandarts",
                "nieuwe patiënten",
                "zorgverlener beschikbaar",
            ),
            breadcrumbLabel = "Patiëntenstop en wachtlijst",
        )
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(topBottom = if (breakpoint >= Breakpoint.MD) 64.px else 32.px, leftRight = 24.px),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(24.px, Alignment.CenterVertically)
        ) {
            Column(
                modifier = Modifier.fillMaxWidth().maxWidth(900.px),
                verticalArrangement = Arrangement.spacedBy(16.px)
            ) {
                H1Heading(
                    text = "Patiëntenstop, klantenstop en wachtlijst: wat betekent dat?",
                    color = MaterialColorVars.Primary.value(),
                    modifier = Modifier.fillMaxWidth()
                )

                SpanText(
                    modifier = Modifier
                        .fillMaxWidth()
                        .fontSize(16.px)
                        .lineHeight(25.px),
                    text = "Een patiëntenstop (of patiënten stop) betekent dat een zorgverlener tijdelijk geen nieuwe patiënten aanneemt. " +
                        "Bij andere sectoren wordt vaker de term klantenstop gebruikt. Beide termen verwijzen naar hetzelfde: beperkte beschikbaarheid."
                )

                SpanText(
                    modifier = Modifier
                        .fillMaxWidth()
                        .fontSize(16.px)
                        .lineHeight(25.px),
                    text = "Een wachtlijst geeft aan dat je wel terecht kan, maar niet onmiddellijk. De wachttijd kan verschillen per regio, discipline en periode."
                )

                SpanText(
                    modifier = Modifier
                        .fillMaxWidth()
                        .fontSize(16.px)
                        .lineHeight(25.px),
                    text = "KlantenStop bundelt deze informatie op één plek zodat je sneller kan zoeken naar huisartsen, tandartsen en andere zorgverleners " +
                        "die nog nieuwe patiënten of klanten aannemen."
                )

                Row(
                    modifier = Modifier.fillMaxWidth().padding(top = 8.px),
                    horizontalArrangement = Arrangement.spacedBy(16.px)
                ) {
                    NavigationItem(
                        title = "Zoek beschikbare zorgverleners",
                        href = Navigation.Screen.Search().route
                    )
                    NavigationItem(
                        title = "Meer over KlantenStop",
                        href = Navigation.Screen.About.route
                    )
                }
            }
        }
    }
}

